import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from "../../mutation-types";
import registrasiApi from "../../../api/registrasi";

const defaultState = () => ({
    konfirmResponse: [],
    registerHistory: []
});

const state = defaultState();

const getters = {};

const mutations = {
    saveConfirmResponse(state, data) {
        state.konfirmResponse = data;
    },
    setRegisterHistory(state, data) {
        state.registerHistory = []
        state.registerHistory = data
    }
};

const actions = {
    registrasiStockist({ commit }, value) {
        /* value = { 'register_sponsor_code': 'GS100001', 'register_member_name': 'putri', 'register_member_email': 'putri.com' }*/
        commit(PROGRESS_START, null, { root: true });
        registrasiApi.registrasiFromStockist(value).then((res) => {
                const data = res.data;
                commit('saveConfirmResponse', data)
            })
            .catch((err) => {
                const data = err.response.data.data;
                commit('saveConfirmResponse', data)
            });
    },

    registrasiMember({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        registrasiApi.registrasiFromMember(value).then((res) => {
                const data = res.data;
                commit('saveConfirmResponse', data)
            })
            .catch((err) => {
                const data = err.response;
                commit('saveConfirmResponse', data)
            });
    },

    getHistoryRegister({ commit }, params) {
        commit(PROGRESS_START, null, { root: true });
        registrasiApi.getHistoryRegister(params).then(({ data: { data } }) => {
                commit(PROGRESS_FINISH, null, { root: true });
                if (data.results.length == 0) {
                    commit('setRegisterHistory', data.results)
                } else {
                    commit('setRegisterHistory', data.results)
                }
            })
            .catch(() => {
                commit(PROGRESS_FAIL, null, { root: true });
                commit('setRegisterHistory', 'error')
            });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};